import { Link } from '@anytag/router';
import { TextCutter } from '@anytag/shared-atoms';
import { useParamsSearch } from '@anytag/shared-hooks';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { ProfilePostsTabs, ProfilePostsTabType } from '@anytag/shared-organisms';
import { MainAccountTemplate } from './main-account-template';
import { CompareAccountTemplate } from './compare-account-template';
import { AnalyticsYoutubeMainSearchSchemaType, CompareAccountType } from './schema-types';

export interface TemplateProps {
  mainSocialAccountId: number;
  comparableAccounts: CompareAccountType[];
}

export const Template = ({ comparableAccounts, mainSocialAccountId }: TemplateProps) => {
  const { filter } = useParamsSearch<AnalyticsYoutubeMainSearchSchemaType>();

  const isMainAccount = mainSocialAccountId === Number(filter.accountId);
  const tabOptions = comparableAccounts.map<ProfilePostsTabType>(({ accountId, channelName, avatarUrl }, i) => ({
    value: String(accountId),
    label: (props) => (
      <Link
        key={`${accountId}_${i}`}
        to="/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos"
        activeOptions={{ exact: true, includeSearch: true }}
        params={{ compareId: String(accountId) }}
        search={(curr: AnalyticsYoutubeMainSearchSchemaType) => ({
          ...curr,
          filter: { ...curr.filter, accountId: String(accountId) }
        })}
        {...props}
      >
        <InfluencerAvatar size="32px" css={{ marginRight: '4px', borderRadius: '50%' }} src={avatarUrl} asChild />
        <TextCutter text={channelName} />
      </Link>
    )
  }));

  return (
    <>
      <ProfilePostsTabs options={tabOptions} />

      {isMainAccount ? (
        <MainAccountTemplate mainSocialAccountId={mainSocialAccountId} />
      ) : (
        <CompareAccountTemplate mainSocialAccountId={mainSocialAccountId} />
      )}
    </>
  );
};
